<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full"
      :footer="false">
    <template #header>
      <span>操作日志</span><span class="modal-secondary-title">{{ name }}</span>
    </template>
    <template #content>
      <app-base-main
          no-padding
          :table-shadow="false">
        <template v-if="isMeaningless(opId)" #filter-group>
          <app-filter-group
              :reset="false"
              @query="$gjNoticeQuery">
            <gj-select
                v-if="object.opObjectTypeOption"
                v-model="filter.operatingObjectType"
                :options="object.opObjectTypeOption"
                placeholder="操作对象"
                width="120px"
            ></gj-select>
            <gj-select
                v-model="filter.operatingType"
                :options="opTypeOption"
                placeholder="操作类型"
                width="120px"
            ></gj-select>
            <gj-select-input
                v-model="filter.keyword"
                :options="[
                  {id: 'asin', text: 'ASIN'},
                  {id: 'keywordText', text: '关键词'},
                  {id: 'negativeKeywordText', text: '否定关键词'},
                ]"
            ></gj-select-input>
            <gj-creator-select
                v-model="filter.createUserId"
                placeholder="操作用户"
            ></gj-creator-select>
            <gj-date-picker
                v-model="filter.date"
                type="daterange"
                tooltip="数据时间"
            ></gj-date-picker>
           <!-- <template #right>
              <gj-button @click="download">导出</gj-button>
            </template>-->
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              :index="false"
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :offset-height="12"
              :pagination="pagination"
              @page-change="$gjNoticeQuery">
            <template v-slot:opObject="{row}">
              <template v-if="isMeaningful(row.portfolioName)">
                <div><span>广告组合：</span><span>{{row.portfolioName | defaultShow}}</span></div>
              </template>
              <template v-if="isMeaningful(row.campaignName)">
                <div><span>广告活动：</span><span>{{row.campaignName | defaultShow}}</span></div>
              </template>
              <template v-if="isMeaningful(row.groupName)">
                <div><span>广告组：</span><span>{{row.groupName | defaultShow}}</span></div>
              </template>
              <template v-if="isMeaningful(row.keywordText)">
                <div><span>关键词：</span><span>{{row.keywordText | defaultShow}}</span></div>
              </template>
              <template v-if="isMeaningful(row.asin)">
                <div><span>商品：</span><span>{{row.asin | defaultShow}}</span></div>
              </template>
              <template v-if="isMeaningful(row.negativeKeywordText)">
                <div><span>否定关键词：</span><span>{{row.negativeKeywordText | defaultShow}}</span></div>
              </template>
              <template v-if="isMeaningful(row.targetText)">
                <div><span>商品投放：</span><span>{{row.targetText | defaultShow}}</span></div>
              </template>
              <template v-if="isMeaningful(row.negativeTargetText)">
                <div><span>否定投放：</span><span>{{row.negativeTargetText | defaultShow}}</span></div>
              </template>
              <template v-if="isMeaningful(row.autoText)">
                <div><span>自动投放：</span><span>{{row.autoText | defaultShow}}</span></div>
              </template>
            </template>
            <template v-slot:operatingObject="{ row }">
              <gj-tooltip
                  :text-line="2"
                  :content="row.operatingObject">
                {{row.operatingObject | defaultShow}}
              </gj-tooltip>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {isMeaninglessMixin, modalMixIn, queryMixin, isMeaningfulMixin} from "../../../../../../minxins";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {defaultVal, isMeaningful} from "../../../../../../utils/common";
  import {exportFile} from "../../../../../../api/common";

  export default {
    name: "app-ad-log-modal",
    mixins: [modalMixIn, queryMixin, isMeaninglessMixin, isMeaningfulMixin],
    props: {
      marketId: {
        required: true
      },
      campaignId: {
        default: null
      },
      groupId: {
        default: null
      },
      adType: {
        required: true,
      },
      object: {
        type: Object,
        required: true
      },
      name: {
        default: ''
      },
      opId: {
        default: null
      },
      operatingObjectTypeProps: {
        default: ""
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'opObject', header: '操作对象', field: 'slot:opObject', minWidth: '200px'},
          {id: 'opType', header: '操作类型', field: 'option:operatingType', minWidth: '100px',
              options: [
                {id: 0, text: '新增广告活动'},
                {id: 1, text: '调整预算'},
                {id: 2, text: '移动分组'},
                {id: 3, text: '修改结束日期'},
                {id: 4, text: '修改状态'},
                {id: 5, text: '修改活动名称'},
                {id: 6, text: '修改竞价策略'},
                {id: 7, text: '新增广告组'},
                {id: 8, text: '调整竞价'},
                {id: 9, text: '修改广告组名称'},
                {id: 10, text: '新增商品'},
                {id: 11, text: '新增关键词'},
                {id: 12, text: '新增否定关键词'},
                {id: 13, text: '新增商品投放'},
                {id: 14, text: '新增否定商品投放'},
                {id: 15, text: '新增广告组合'},
                {id: 16, text: '新增广告活动草稿'},
                {id: 17, text: '修改广告活动草稿'},
                {id: 18, text: '广告活动草稿提交审核'},
              ]},
          {id: 'content', header: '操作详情', field: 'content', overflowLine: 2, minWidth: '250px'},
          {id: 'operatingObject', header: '操作结果', field: 'slot:operatingObject', minWidth: '50px'},
          {id: 'opUser', header: '操作用户', field: 'createUser', minWidth: '100px'},
          {id: 'createDate', header: '操作时间', field: 'createDate', minWidth: '120px'},
        ],
        filter: {
          operatingObjectType: null,
          operatingType: null,
          createUserId: null,
          keyword: {
            key: 'asin',
            value: null
          },
          date: null,
        }
      }
    },
    watch: {
      'filter.operatingObjectType': {
        handler(operatingObjectType) {
          this.filter.operatingType = null;
        },
        immediate: true
      }
    },
    computed: {
      opTypeOption() {
        if (isMeaningful(this.filter.operatingObjectType)) {
          for (let key in this.adType) {
            if (this.adType[key].objectType === this.filter.operatingObjectType) {
              return this.adType[key].opTypeOption;
            }
          }
        }
        return [];
      }
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            campaignId: this.campaignId,
            groupId: this.groupId,
            operatingObjectType: defaultVal(this.filter.operatingObjectType, null),
            operatingType: defaultVal(this.filter.operatingType, null),
            createUserId: defaultVal(this.filter.createUserId, null),
            startDate: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[0]) : null,
            endDate: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        if (isMeaningful(this.opId)) {
          params.model[this.object.opId] = this.opId;
        }
        this.globalParams = params;
        // 查询
        this.loading = true;
        this.$gjRequest.post(this.adType.queryUrl, params)
          .then(({data}) => {
            this.tableData = (data.records || []);
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      },
      download() {
        exportFile(this.adType.exportUrl, this.globalParams);
      }
    },
    created() {
      this.operatingObjectTypeProps && (this.filter.operatingObjectType = this.operatingObjectTypeProps)
    }
  }
</script>

<style scoped lang="scss">
/deep/.vxe-table--border-line{
    border: 1px solid #d8dadd !important;
  }
/deep/.footer__pagination {
  padding-top: 16px;
}
/deep/.vxe-header--column {
  background: #f6f8fb !important;
}
</style>
